import { type ComponentPropsWithoutRef, forwardRef } from 'react';
import { cn } from '@/utils/tailwind.util';

/**
 * QuizCardRoot - 레이아웃과 스타일링이 있는 카드 래퍼
 * EditableQuizCard/QuizCardUI.tsx (QuizCardRoot)에서 복사
 * @component
 */
const QuizCardRoot = forwardRef<HTMLElement, ComponentPropsWithoutRef<'article'>>((props, ref) => {
  const {
    children,
    className,
    ...rest
  } = props;
  return <article ref={ref} className={cn('w-full cursor-default flex flex-col items-center bg-default border border-alternative rounded-md overflow-hidden flex-shrink-0', className)} {...rest}>
      {children}
    </article>;
});
QuizCardRoot.displayName = 'QuizCardRoot';
export { QuizCardRoot };